import * as dayjs from "dayjs";

export const CAMPAIGN_TYPES = {
  FREE_SHIPPING_750: "free_shipping_750",
  ORDER_500: "order_500",
  DISCOUNT_5_PERCENT: "discount_5_percent",
  WELCOME_DISCOUNT: "welcome_discount",
};

export const calculateNextThousand = (cartValue) => {
  if (!cartValue || cartValue <= 0) {
    return 1000;
  }
  return Math.ceil(cartValue / 1000) * 1000;
};

export const canSendMarketingEmail = (marketingEmails, type, minDaysAgo = 7) => {
  if (!marketingEmails || marketingEmails.length === 0) {
    return { canSend: true, daysAgo: null };
  }

  const emailsOfType = marketingEmails.filter((email) => email.type === type);
  
  if (emailsOfType.length === 0) {
    return { canSend: true, daysAgo: null };
  }

  const lastEmail = emailsOfType[0];
  const sentAt = dayjs.unix(lastEmail.sentAt);
  const daysAgo = dayjs().diff(sentAt, "day");

  return {
    canSend: daysAgo >= minDaysAgo,
    daysAgo,
    lastSentAt: sentAt,
  };
};

export const getEmailTypeLabel = (type) => {
  switch (type) {
    case CAMPAIGN_TYPES.FREE_SHIPPING_750:
      return "Gratis verzending €750";
    case CAMPAIGN_TYPES.ORDER_500:
      return "Bestellen vanaf €500";
    case CAMPAIGN_TYPES.DISCOUNT_5_PERCENT:
      return "5% korting";
    case CAMPAIGN_TYPES.WELCOME_DISCOUNT:
      return "Welkomstkorting";
    default:
      return type;
  }
};

export const getEmailTypeDescription = (type, data = {}) => {
  switch (type) {
    case CAMPAIGN_TYPES.FREE_SHIPPING_750:
      return "Alleen vandaag gratis verzending bij bestellingen vanaf €750";
    case CAMPAIGN_TYPES.ORDER_500:
      return "Alleen vandaag bestellen vanaf €500";
    case CAMPAIGN_TYPES.DISCOUNT_5_PERCENT:
      const threshold = data.calculatedThreshold || 0;
      const percentage = data.customDiscountPercentage || 5;
      return `Alleen vandaag ${percentage}% korting bij bestellingen boven €${threshold.toLocaleString("nl-NL")}`;
    case CAMPAIGN_TYPES.WELCOME_DISCOUNT:
      const welcomePercentage = data.customDiscountPercentage || 10;
      return `Alleen vandaag ${welcomePercentage}% welkomstkorting voor nieuwe klanten`;
    default:
      return "";
  }
};

export const getEmailTypeColor = (type) => {
  switch (type) {
    case CAMPAIGN_TYPES.FREE_SHIPPING_750:
      return "green";
    case CAMPAIGN_TYPES.ORDER_500:
      return "blue";
    case CAMPAIGN_TYPES.DISCOUNT_5_PERCENT:
      return "orange";
    case CAMPAIGN_TYPES.WELCOME_DISCOUNT:
      return "purple";
    default:
      return "default";
  }
};

export const getEmailTypeIcon = (type) => {
  switch (type) {
    case CAMPAIGN_TYPES.FREE_SHIPPING_750:
      return "🎁";
    case CAMPAIGN_TYPES.ORDER_500:
      return "💰";
    case CAMPAIGN_TYPES.DISCOUNT_5_PERCENT:
      return "🎉";
    case CAMPAIGN_TYPES.WELCOME_DISCOUNT:
      return "👋";
    default:
      return "📧";
  }
};

export const calculateCartValue = (cart) => {
  if (!cart || !cart.products || cart.products.length === 0) {
    return 0;
  }
  return cart.products.reduce((sum, product) => sum + product.price * product.quantity, 0);
};

export const getExpiresAtEndOfDay = () => {
  return dayjs().endOf("day").unix();
};

export const formatTimeSinceSent = (sentAtTimestamp) => {
  const sentAt = dayjs.unix(sentAtTimestamp);
  const now = dayjs();
  const daysAgo = now.diff(sentAt, "day");
  
  // If sent today (0 days ago), show exact time
  if (daysAgo === 0) {
    const hoursAgo = now.diff(sentAt, "hour");
    const minutesAgo = now.diff(sentAt, "minute");
    
    if (hoursAgo === 0) {
      if (minutesAgo === 0) {
        return "Zojuist verstuurd";
      }
      return `${minutesAgo} ${minutesAgo === 1 ? 'minuut' : 'minuten'} geleden`;
    }
    return `${hoursAgo} ${hoursAgo === 1 ? 'uur' : 'uur'} geleden`;
  }
  
  // Otherwise show days
  return `${daysAgo} ${daysAgo === 1 ? 'dag' : 'dagen'} geleden`;
};
